"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _react2 = require("../..");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    height: ", "px;\n    border: ", ";\n    outline: none;\n    margin: ", ";\n    opacity: ", ";\n    cursor: ", ";\n    overflow: hidden;\n    padding: 0px;\n    line-height: ", ";\n        &: hover {\n        background: ", ";\n    }\n        &: active {\n        background: ", "\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonWrapper = _styledComponents["default"].button(_templateObject(), function (props) {
  return props.colors.backgroundColor;
}, function (props) {
  return props.colors.textColor;
}, function (props) {
  return props.dense ? props.spacingObj.baseFontSize + 'rem' : props.spacingObj.largeFontSize + 'rem';
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.dense ? 32 : 40;
}, function (props) {
  return props.outlined ? '1px solid ' + props.colors.borderColor : 'none';
}, function (props) {
  return props.spacingObj.padding + 'px';
}, function (props) {
  return props.disabled ? .5 : 1.0;
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.dense ? props.spacingObj.padding * 4 + 'px' : props.spacingObj.padding * 5 + 'px';
}, function (props) {
  return !props.disabled ? props.colors.backgroundHover : props.colors.backgroundColor;
}, function (props) {
  return props.colors.backgorundActive;
});

function Button(props) {
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[props.type];
  var colors = context.getColors()[props.type];
  var iconNode = null;

  if (props.icon) {
    iconNode = /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
      iconid: props.icon,
      size: "small",
      style: {
        lineHeight: 'normal',
        margin: 'auto 0px auto auto',
        paddingRight: spacing.padding + 'px'
      },
      color: colors.iconColor
    });
  }

  return /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
    style: props.style,
    spacingObj: spacing,
    colors: colors,
    fontFamilyObj: context.getFont(),
    onClick: props.onClick,
    dense: props.dense,
    outlined: props.type === 'outlined',
    disabled: props.disabled,
    icon: props.icon
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      paddingLeft: spacing.padding * 3 + 'px',
      paddingRight: spacing.padding * 3 + 'px'
    }
  }, props.children), iconNode);
}

Button.propTypes = {
  /**The content displayed inside the button. */
  children: _propTypes["default"].node,

  /**Inherits styling based on the type of button to display. Values are default, primary, secondary and outlined*/
  type: _propTypes["default"].string,

  /**Toggle to enable and disable the button control. */
  disabled: _propTypes["default"].bool,

  /**Extends the base styling of the button element. */
  style: _propTypes["default"].object,

  /**SUBJECT TO CHANGE */
  icon: _propTypes["default"].string,

  /**Toggles the size of the button. Passing dense produces a larger button. */
  dense: _propTypes["default"].bool,

  /**The callback function fired when the button is clicked. */
  onClick: _propTypes["default"].func
};
Button.defaultProps = {
  type: 'default',
  disabled: false,
  style: {},
  icon: null,
  dense: false,
  onClick: function onClick() {
    return false;
  }
};